import { createApp, reactive, provide, h } from 'vue'
import App from './App.vue'
import router from './router';
import { ApolloClient, InMemoryCache, gql, from } from '@apollo/client/core';
import { DefaultApolloClient } from '@vue/apollo-composable';
import { Observable } from 'apollo-link';
import jwt_decode from "jwt-decode";

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

import { createStore } from 'vuex'

import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http'
import { defineCustomElements } from '@ionic/pwa-elements/loader';

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_GRAPHQL_URI
})

const defaultOptions = { 
  watchQuery: {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  },
  query: {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  },
  mutate: {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  }
}


const links = ApolloLink.from([
  httpLink,
]);

const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false
  }),
  link: links,
  defaultOptions
})

export const store = createStore({
  state () {
    return {
    }
  },
  actions: {
  },
  mutations: {
  },
  getters: {
  }
})

const app = createApp(
  {
    setup () {
      provide(DefaultApolloClient, apolloClient)
    },
    render() {
      return h(App)
    }
  }
).use(IonicVue)
 .use(router)
  
router.isReady().then(() => {
  app.mount('#app');
  defineCustomElements(window)
});


